/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Bypass_RadiosInputs */

const en_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass radios`)
};

const ar_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجاوز الإشارات`)
};

const bn_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাইপাস রেডিও`)
};

const de_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkgeräte umgehen`)
};

const es_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitir radios`)
};

const fr_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contourner les radios`)
};

const pt_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar rádios`)
};

const zh_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旁路无线电`)
};

const tr_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass radios`)
};

const ru_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обход радиостанций`)
};

const pl_svchip_bypass_radios = /** @type {(inputs: Svchip_Bypass_RadiosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omiń radiotelefony`)
};

/**
* | output |
* | --- |
* | "Bypass radios" |
*
* @param {Svchip_Bypass_RadiosInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_bypass_radios = /** @type {((inputs?: Svchip_Bypass_RadiosInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Bypass_RadiosInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_bypass_radios(inputs)
	if (locale === "bn") return bn_svchip_bypass_radios(inputs)
	if (locale === "de") return de_svchip_bypass_radios(inputs)
	if (locale === "es") return es_svchip_bypass_radios(inputs)
	if (locale === "fr") return fr_svchip_bypass_radios(inputs)
	if (locale === "pt") return pt_svchip_bypass_radios(inputs)
	if (locale === "zh") return zh_svchip_bypass_radios(inputs)
	if (locale === "tr") return tr_svchip_bypass_radios(inputs)
	if (locale === "ru") return ru_svchip_bypass_radios(inputs)
	if (locale === "pl") return pl_svchip_bypass_radios(inputs)
	return en_svchip_bypass_radios(inputs)
});